import React from 'react'
import styled from 'styled-components'
import { spacing, color } from '../theme'

/* This styling is also used in CustomRadioBtn.js */
export const CheckBoxWrapper = styled.div`
   width: 15px;
   height: 15px;
   position: relative;
   margin-right: ${spacing.sm};
   display: inline-block;

   input[type='radio'],
   input[type='checkbox'] {
      position: absolute;
      left: -10000px;
      top: auto;
      width: 1px;
      height: 1px;
      overflow: hidden;

      & + span {
         &:before {
            content: '';
            display: inline-block;
            width: 15px;
            height: 15px;
            background: ${color.white};
            border: 1px solid ${color.primary};
            border-radius: 2px;
            position: absolute;
            left: 0;
            top: 0;
         }
      }

      &:checked + span {
         &:after {
            content: '';
            display: inline-block;
            width: 9px;
            height: 9px;
            background: ${color.primary};
            position: absolute;
            left: 3px;
            top: 3px;
         }
      }
   }
`

export const CustomCheckbox = ({ ...props }) => {
   return (
      <CheckBoxWrapper>
         <input {...props} />
         <span></span>
      </CheckBoxWrapper>
   )
}
